import { useState } from 'react'
import { FormattedMessage, useIntl, defineMessages } from 'react-intl'
import styled from 'styled-components'

import { CompanyAutocomplete } from 'features/Companies/components/CompanyAutocomplete'
import { useLogin } from 'features/Login/hooks'
import { canSelectCompany } from 'features/Login/utils'

const CompanyAutocompleteWrapper = styled.div<TSFixMe>`
  margin-bottom: 20px;
`

const messages = defineMessages({
  companyPlaceholder: {
    id: 'ancillaries.selectCompany.placeholder',
    defaultMessage: 'Select first your company'
  }
})

export const withCompany =
  (Component: TSFixMe): TSFixMe =>
  // eslint-disable-next-line react/display-name
  (props: TSFixMe): TSFixMe => {
    const intl = useIntl()
    const login = useLogin()
    const [company, setCompany] = useState({ id: '', name: '' })

    const showCompany = canSelectCompany(login.accessToken)

    return (
      <>
        {showCompany && (
          <CompanyAutocompleteWrapper>
            <CompanyAutocomplete
              id="company.id"
              onChange={setCompany}
              value={company.name}
              placeholder={intl.formatMessage(messages.companyPlaceholder)}
              label={<FormattedMessage id="dictionary.company" defaultMessage="Company" />}
            />
          </CompanyAutocompleteWrapper>
        )}
        <Component company={showCompany ? company : { id: login.accessToken.companyId }} {...props} />
      </>
    )
  }
